/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlDetailFilter {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlDetailFilter.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlDetailFilter>): ComplianceAssessmentControlDetailFilter {
        let obj = Object.assign(new ComplianceAssessmentControlDetailFilter(), model);
        ComplianceAssessmentControlDetailFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlDetailFilter>): ComplianceAssessmentControlDetailFilter {
        if (!model) return null;
        return ComplianceAssessmentControlDetailFilter.newInstance(<ComplianceAssessmentControlDetailFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlDetailFilter) {
        if (!obj) return;

        models.ComplianceAssessmentControlDetailFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlDetailFilter): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlDetailFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    assessment_history_ids: Array<string>;

    /**
     * Search based on family, sub-family, nature
     */
    search: string;

    /**
     * Query based on family, sub-family, nature, severity, and control_status
     */
    query: models.QueryOperator;

}
